import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { GetLabOrder } from "../../services/OrderService";
import LabOrderOverview from "./LabOrderOverView";
import LabOrderActions from "./LabOrderActions";
import OrderBillingView from "./OrderBillingView";
import OrderReportingView from "./OrderReportingView";
import SamplesTable from "../samples/SamplesTable";
import ResultsTable from "../results/ResultsTable";
import CommonLoader from "../common/CommonLoader";
import { NotificationManager } from "react-notifications";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import OrderAttachmentsTable from "../lab-orders/OrderAttachmentsTable";

import { IconButton, Tooltip } from "@mui/material";

const ViewLabOrder = () => {
  const [loading, setLoading] = useState(false);
  const [labOrderData, setLabOrderData] = useState(null);
  const { orderNumber } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getLabOrder(orderNumber);
  }, [orderNumber]);

  const getLabOrder = async (orderNumber) => {
    try {
      setLoading(true);
      let response = await GetLabOrder(orderNumber);
      setLabOrderData(response.results);
    } catch (err) {
      NotificationManager.error("Error getting order. " + err, "Error");
    } finally {
      setLoading(false);
    }
  };

  const handleViewInvoiceClick = (invoiceNumber) => {
    const orderUrl = `/vlp/invoices/${invoiceNumber}`;
    if (window.invoiceViewWindow && !window.invoiceViewWindow.closed) {
      window.invoiceViewWindow.location.href = orderUrl;
    } else {
      window.invoiceViewWindow = window.open(
        orderUrl,
        "_blank",
        "resizable=yes,scrollbars=yes"
      );
    }
  };

  const goToNextOrder = () => {
    const nextOrderNumber = parseInt(orderNumber) + 1;
    navigate(`/vlp/lab-orders/${nextOrderNumber}`);
  };

  const goToPreviousOrder = () => {
    const previousOrderNumber = parseInt(orderNumber) - 1;
    navigate(`/vlp/lab-orders/${previousOrderNumber}`);
  };

  return (
    <div className="vlp-component-container">
      <div
        className="order-navigation-buttons"
        style={{ display: "flex", justifyContent: "flex-start" }}
      >
        <Tooltip title="Move to Previous Order">
          <IconButton onClick={goToPreviousOrder}>
            <ArrowBackRoundedIcon
              style={{ color: "rgb(25,118,210)", fontWeight: "bold" }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title="Move to Next Order">
          <IconButton onClick={goToNextOrder}>
            <ArrowForwardRoundedIcon
              style={{ color: "rgb(25,118,210)", fontWeight: "bold" }}
            />
          </IconButton>
        </Tooltip>
      </div>

      <span className="title">
        Order Details #{" "}
        <span style={{ color: "rgb(25,118,210)", fontWeight: "bold" }}>
          {orderNumber}
        </span>
      </span>

      <hr />
      {labOrderData !== null &&
        labOrderData.invoiceNumber !== null &&
        labOrderData.invoiceNumber !== "" && (
          <span className="">
            Invoice #{" "}
            <a
              style={{ color: "rgb(25,118,210)", fontWeight: "bold" }}
              onClick={() => handleViewInvoiceClick(labOrderData.invoiceNumber)}
            >
              {labOrderData.invoiceNumber}
            </a>
          </span>
        )}

      <div className="columns">
        <div className="column"></div>
      </div>      
      {labOrderData !== null && <LabOrderActions orderNumber={labOrderData.orderNumber} />}
      {labOrderData !== null && <LabOrderOverview order={labOrderData} />}            
      {labOrderData !== null && <OrderBillingView order={labOrderData} />}
      {labOrderData !== null && <OrderReportingView order={labOrderData} />}
      {labOrderData !== null && <SamplesTable samples={labOrderData.samples} />}
      {labOrderData !== null && <ResultsTable results={labOrderData.results} orderNumber={orderNumber} />}
      {/* {labOrderData !== null && <OrderShippingView order={labOrderData} />} */}
      {orderNumber !== null && <OrderAttachmentsTable orderNumber={orderNumber} />}

      <CommonLoader loading={loading} />
    </div>
  );
};

export default ViewLabOrder;
